export default "__VITE_ASSET__Dje_fVCp__"